import { render, staticRenderFns } from "./Sticker.vue?vue&type=template&id=4a104dea&scoped=true&"
import script from "./Sticker.vue?vue&type=script&lang=js&"
export * from "./Sticker.vue?vue&type=script&lang=js&"
import style0 from "./Sticker.vue?vue&type=style&index=0&id=4a104dea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a104dea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a104dea')) {
      api.createRecord('4a104dea', component.options)
    } else {
      api.reload('4a104dea', component.options)
    }
    module.hot.accept("./Sticker.vue?vue&type=template&id=4a104dea&scoped=true&", function () {
      api.rerender('4a104dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/DeviceSetting/coordi/Sticker.vue"
export default component.exports